<template>
  <div class="px-10">
    <v-row>
      <v-col>
        <span class="font-16 font-calibri font-weight-bold">Company</span>
        <employee-profile-payroll-payroll-company-company-dialog-create
          v-if="$hasPermissionTo(['create employee payroll']) && !isResigned"
          :employee-uid="employeeUid"
          :company-employees="companyEmployees"
          @created="loadData(); $emit('updated')"
        />
      </v-col>
    </v-row>

    <v-tabs vertical>
      <v-tab
        v-for="(companyEmployee,i) in companyEmployees"
        :key="i"
      >
        {{ companyEmployee.company.name }}
      </v-tab>

      <v-tab-item
        v-for="(companyEmployee,i) in companyEmployees"
        :key="i"
      >
        <v-card>
          <employee-profile-payroll-payroll-company-company-container-view
            :company-employee="companyEmployee"
            :is-resigned="isResigned"
            @load="loadData(); $emit('updated')"
            @deleted="loadData(); $emit('updated')"
          />
          <v-divider class="mt-3" />

          <employee-profile-payroll-payroll-company-pay-status-container-view
            :company-employee="companyEmployee"
            @load="loadData()"
          />
          <v-divider class="mt-3" />

          <employee-profile-payroll-payroll-company-payment-details-container-view
            :company-employee="companyEmployee"
            @load="loadData()"
          />

          <employee-profile-payroll-payroll-company-basic-salary-container-view
            :company-employee="companyEmployee"
            @load="loadData()"
          />
          <v-divider class="mt-3" />

          <employee-profile-payroll-payroll-company-cost-center-container-view
            :company-employee="companyEmployee"
            @load="loadData(); $emit('updated')"
          />
          <v-divider class="mt-3" />

          <employee-profile-payroll-payroll-company-contribution-container-view
            :company-employee="companyEmployee"
            @load="loadData()"
          />
          <v-divider class="mt-3" />

          <employee-profile-payroll-payroll-company-doe-container-view
            :company-employee="companyEmployee"
            @load="loadData()"
          />
          <v-divider class="mt-3" />

          <employee-profile-payroll-payroll-company-additional-deduction-container-view
            :company-employee="companyEmployee"
            @load="loadData()"
          />
        
          <v-divider class="mt-3" />
          
          <employee-profile-payroll-payroll-company-previous-remuneration-container-view
            :company-employee="companyEmployee"
            @created="loadData()"
            @updated="loadData()"
          />
          <v-divider class="mt-3" />

          <employee-profile-payroll-payroll-company-benefit-in-kind-container-view
            :company-employee="companyEmployee"
            @load="loadData()"
          />
          <v-divider class="mt-3" />
          
          <employee-profile-payroll-payroll-company-non-resident-tax-container-view
            :company-employee="companyEmployee"
            @load="loadData()"
          />
          <v-divider class="mt-3" />

          <employee-profile-payroll-payroll-company-payslip-container-view 
            :company-employee="companyEmployee"
          />
          <v-divider class="mt-3" />

          <employee-profile-payroll-payroll-company-pcb-statement-container-view 
            :company-employee="companyEmployee"
            @load="loadData()"
          />
          <v-divider class="mt-3" />

          <employee-profile-payroll-payroll-company-pcb-arrear-container-view
            :company-employee="companyEmployee"
            @load="loadData()"
          />
          <v-row class="mt-3" />
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyCompanyContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/company/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyContributionContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/contribution/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyDoeContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/doe/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyPreviousRemunerationContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/previous-remuneration/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyCostCenterContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/cost-center/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyBasicSalaryContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/basic-salary/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyCompanyDialogCreate: () => import('@/components/hris/employee/profile/payroll/payroll-company/company/DialogCreate'),
      EmployeeProfilePayrollPayrollCompanyBenefitInKindContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/benefit-in-kind/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyAdditionalDeductionContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/additional-deduction/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyNonResidentTaxContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/non-resident-tax/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyPayslipContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/payslip/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyPcbStatementContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/pcb-statement/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyPcbArrearContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/pcb-arrear/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyPaymentDetailsContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/payment-details/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyPayStatusContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/pay-status/ContainerView'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        companyEmployees: [],
      }
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadData()
          }
        },
      },
    },

    methods: {
      loadData () {
        Promise.all([
          this.$api.hrisCompanyEmployees().show(this.employeeUid),
        ])
          .then(([companyEmployee]) => {
            this.companyEmployees = companyEmployee.data
            this.$emit('loaded')
          })
      },
    },

  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}
</style>
